import { PublicOrderSummary } from "common/types";
import { FulfillmentShipmentStatus } from "../../types";

export const filterInvalidShipments = (shipments: PublicOrderSummary["shipments"]) =>
  shipments.filter(
    (shipment) => ![FulfillmentShipmentStatus.ERROR, FulfillmentShipmentStatus.CANCELLED].includes(shipment.status)
  );
